// extracted by mini-css-extract-plugin
module.exports = {"agentAvatar":"AgentAvatar_agentAvatar__13jKM"};